// Module
var code = "<div layout=\"row\" md-colors=\"{background: 'grey-50'}\" class=\"full-height\"> <ui-view flex></ui-view> </div> ";
// Exports
export default code;